import React from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@boi/react-icons";
import { ButtonV2 as Button, LinkWithIcon, Link } from "@boi/react-components";
import { StyledButton } from "./simple-button.styles";
import { ConditionalWrapper, Icon } from "../theme/style-utils-coras-nua";
import styled, { css } from "styled-components";
import { flexbox, layout, space } from "styled-system";

const MonotoneButton = ({ ...props }) => (
    <StyledButton monotone="true" {...props} />
);

const PrimaryButton = (props) => {
    const { disabled, onClick, text, title, ...restProps } = props;
    const isAnchorLink = restProps.as === "a" && !!restProps.href;
    const handleClick = () => {
        isAnchorLink ? openUrl(restProps.href) : onClick()
    }
    const openUrl = url => {
        window.location.href = url
    };

    return (
        <Button
            variant="primary"
            isDisabled={disabled || restProps.className === "disabled"}
            aria-label={restProps['aria-label']}
            onClick={handleClick}>
            {text || title || restProps.children}
        </Button>
    )
}

const SecondaryButton = ({ order = "initial", ...props }) => {
    const { disabled, onClick, text, title, startIcon, fullWidth, ...restProps } = props;
    const isAnchorLink = restProps.as === "a" && !!restProps.href;
    const handleClick = () => {
        isAnchorLink ? openUrl(restProps.href) : onClick()
    }
    const openUrl = url => {
        window.location.href = url
    };

    return (<div style={{ order }}>
        <Button
            variant="secondary"
            isDisabled={disabled}
            aria-label={restProps['aria-label']}
            fullWidth={fullWidth}
            startIcon={startIcon}
            onClick={handleClick}>
            {text || title || restProps.children}
        </Button>
    </div>)
};


const WarningButton = ({ ...props }) => (
    <StyledButton warning="true" {...props} />
);

const IconWrapper = styled("span")`
    ${flexbox}
    ${layout}
    ${space}
    justify-content: ${props =>
        props.justifyContent ? props.justifyContent : "left"}
    ${StyledButton} {
        width: auto;
    }
    ${props =>
        props.position === "left" &&
        css`
            ${StyledButton} {
                order: 2;
            }
            svg {
                order: 1;
            }
        `}
    ${props =>
        props.position === "right" &&
        css`
            ${StyledButton} {
                order: 1;
            }
            svg {
                order: 2;
            }
        `}
`;
IconWrapper.defaultProps = {
    display: "flex",
    width: "auto",
    alignItems: "center"
};

const HyperLink = ({ icon, iconPosition, justifyContent, ...props }) => {
    return (
        <ConditionalWrapper
            condition={icon}
            wrapper={children => (
                <IconWrapper
                    position={iconPosition}
                    className={props.className}
                    justifyContent={justifyContent}>
                    <Icon icon={icon} className={`u-mx-2`} />
                    {children}
                </IconWrapper>
            )}>
            <StyledButton
                link="true"
                width="auto"
                mb={0}
                px={0}
                mx={0}
                {...props}
            />
        </ConditionalWrapper>
    );
};

HyperLink.defaultProps = {
    icon: "",
    iconPosition: "",
    justifyContent: ""
};

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    order: ${props => props.$order} !important;
`;

const BackButton = ({ children, order = "-1", ...props }) => {
    return (
        <ButtonWrapper back $order={order}>
            <LinkWithIcon
                startIcon={<ArrowLeftIcon />}
                variant="bodyM"
                isUnderlined={false}
                href="#application/page/2"
                {...props}
                >
                {children}
            </LinkWithIcon>
        </ButtonWrapper>
    )
};

const ForwardButton = ({ children, ...props }) => {
    return (
        <ButtonWrapper forward {...props}>
            <LinkWithIcon
                endIcon={<ArrowRightIcon />}
                variant="bodyM"
                isUnderlined={false}
                {...props}
                >
                {children}
            </LinkWithIcon>
        </ButtonWrapper>
    )
};

const NeedHelpButton = ({ children, ...props }) => {
    return (
        <ButtonWrapper>
            <Link
                role="button"
                href="#"
                variant="bodyM"
                isUnderlined={false}
                {...props}
                >
                {children}
            </Link>
        </ButtonWrapper>
    )
};

export {
    MonotoneButton,
    PrimaryButton,
    SecondaryButton,
    WarningButton,
    HyperLink,
    BackButton,
    ForwardButton,
    NeedHelpButton
};
